import type { MobileOperator } from '@/types/portal';

interface OperatorStepProps {
  operators: MobileOperator[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

/** "Please enter the operator" — pick the mobile money network to settle on. */
export default function OperatorStep({ operators, selectedId, onSelect }: OperatorStepProps) {
  return (
    <div className="space-y-5">
      <h3 className="font-heading text-lg font-semibold text-foreground-950">
        Please enter the operator
      </h3>
      <ul className="divide-y divide-background-100">
        {operators.map((operator) => {
          const active = selectedId === operator.id;
          return (
            <li key={operator.id}>
              <button
                type="button"
                onClick={() => onSelect(operator.id)}
                className="flex w-full cursor-pointer items-center gap-3 py-3.5 text-left"
              >
                <span
                  className="flex h-9 w-9 items-center justify-center rounded-full text-sm font-label font-bold text-white"
                  style={{ backgroundColor: operator.color }}
                >
                  {operator.mark}
                </span>
                <span className="flex-1 text-sm font-medium text-foreground-900">
                  {operator.name}
                </span>
                <span
                  className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                    active
                      ? 'border-primary-500 bg-primary-500 text-background-50'
                      : 'border-background-400'
                  }`}
                >
                  {active ? <i className="ri-check-line text-xs" /> : null}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}